import {Link} from 'react-router-dom'
import styled from 'styled-components'

export const LinkEl = styled(Link)`
  text-decoration: none;
`

export const NonHomeVidItem = styled.li`
  display: flex;
  margin: 28px 32px 16px 32px;
`
export const ThumbnailImg = styled.img`
  height: 220px;
`
